import ApexCharts from "apexcharts";
import React, { useRef, useState } from "react";

import { CalendarDateRange, SelectItem } from "@fronterahealth/frontera-ui-components";

import { ApiReportGoalChartTypeChoices, ReportGoalType } from "@api/graphql/types-and-hooks";
import { useCaptureCell } from "@components/ChartCapture/hooks/useCaptureCell";
import { CellOutcome } from "@components/ChartCapture/types";
import {
  ShortTermGoalProgressGraph,
  selectItemForGoalChartType,
} from "@components/ShortTermGoalPanel/ShortTermGoalProgressGraph";

export const GoalCaptureCell: React.FC<{
  goal: ReportGoalType;
  onResult: (outcome: CellOutcome) => void;
  onStart?: () => void;
}> = ({ goal, onResult, onStart }) => {
  const chartRef = useRef<ApexCharts>(null);
  const handleReady = useCaptureCell(chartRef, onResult, onStart);
  const [selectedChart, setSelectedChart] = useState<SelectItem>(() =>
    selectItemForGoalChartType(
      (goal.chartType as ApiReportGoalChartTypeChoices) ?? ApiReportGoalChartTypeChoices.Progress,
    ),
  );
  const [filterSessionDates, setFilterSessionDates] = useState<CalendarDateRange | undefined>({});

  // Empty `signedChartImageUrl` forces the live chart (not the static <img>),
  // so this captures even for already-approved items during sign-time backfill.
  return (
    <ShortTermGoalProgressGraph
      reportGoal={goal}
      selectedChart={selectedChart}
      setSelectedChart={setSelectedChart}
      signedChartImageUrl=""
      chartRef={chartRef}
      filterSessionDates={filterSessionDates}
      setFilterSessionDates={setFilterSessionDates}
      onSelectedChartReady={handleReady}
    />
  );
};
